module.exports = __webpack_public_path__ + "img/Вертельный бурсит (трохантерит, тенденит большого вертела).6116f6f7.jpg";